import { MySigningModals } from "@pharmupp/p3-document-domain"

export const AdhGlobalModals = () => (
  <>
    <MySigningModals />
  </>
)
